import type { ElementOf } from 'ts-essentials';
import { BigNumber } from 'bignumber.js';
import { default as kovan } from '../blockchain/addresses/kovan.json';
import { default as polkadot } from '../blockchain/addresses/polkadot.json';
import { default as moonbeam } from '../blockchain/addresses/moonbeam.json';
import {
  getCollateralJoinContracts,
  getMcdData,
} from 'blockchain/addresses/addressesUtils';
import { amountFromWei } from 'utils/contract/common-function';
import { Vault } from 'types';
import { zero } from 'constants/number';
import { ethers } from 'ethers';

export const WAD = new BigNumber('1e18');
export const RAY = new BigNumber('1e27');
export const RAD = new BigNumber('1e45');

export const HOUR = 60 * 60;
export const DAY = 24 * HOUR;
export const SECONDS_PER_YEAR = 365 * DAY;

export const LOAN_ACTION = {
  open: 'Open new loan',
  manage: 'Manage loan',
};

export const MaxUint =
  '115792089237316195423570985008687907853269984665640564039457584007913129639935';

export const maxUint256 = amountFromWei(
  new BigNumber(
    '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff',
    16,
  ),
);

export const defaultAddress = '0xd9fA1a4e89c3BF376F97bAf671C234419581b0C4';

export const COIN_TAGS = ['stablecoin', 'lp-token'] as const;
export type CoinTag = ElementOf<typeof COIN_TAGS>;

export const MULTICHAIN = {
  kovan: {
    ...kovan,
  },
  polka: {
    ...polkadot,
  },
  moonbeam: {
    ...moonbeam,
  },
};

export const mcdData = (network = 'polka') => {
  return getMcdData(MULTICHAIN[network]);
  // return {
  //   ETH: {
  //     abi: mcdOsmAbi,
  //     address: MULTICHAIN[network].PIP_ETH
  //   }
  // }
};

export const SUPPORTED_CHAINS = [
  {
    chainId: '0xb',
    chainName: 'PolkaFoundry',
    nativeCurrency: {
      name: 'HLB',
      symbol: 'HLB',
      decimals: 18,
    },
    rpcUrls: ['http://3.0.99.164:31378'],
  },
];

export const MULTICHAIN_SETUP = {
  kovan: {
    token: { ...getCollateralJoinContracts(kovan) },
    address: { ...kovan },
    nativeSymbol: 'ETH',
    // mcdData: getMcdData(kovan),
    joinsIlk: getCollateralJoinContracts(kovan),
  },
  polka: {
    token: { ...getCollateralJoinContracts(polkadot) },
    address: { ...polkadot },
    nativeSymbol: 'HLB',
    // mcdData: getMcdData(polkadot),
    joinsIlk: getCollateralJoinContracts(polkadot),
  },
  moonbeam: {
    token: { ...getCollateralJoinContracts(moonbeam) },
    address: { ...moonbeam },
    nativeSymbol: 'DEV',
    // mcdData: getMcdData(moonbeam),
    joinsIlk: getCollateralJoinContracts(moonbeam),
  },
};

export const defaultLoanData = {
  collateralizationDangerThreshold: zero,
  collateralizationWarningThreshold: zero,
  currentPrice: zero,
  currentPriceUpdate: undefined,
  debtCeiling: zero,
  debtFloor: zero,
  debtScalingFactor: zero,
  feeLastLevied: undefined,
  ilk: '',
  ilkDebt: zero,
  ilkDebtAvailable: zero,
  isStaticPrice: false,
  liquidationPenalty: zero,
  liquidationRatio: zero,
  liquidatorAddress: ethers.constants.AddressZero,
  maxAuctionLotSize: zero,
  maxDebtPerUnitCollateral: zero,
  nextPrice: zero,
  nextPriceUpdate: undefined,
  normalizedIlkDebt: zero,
  percentageChange: zero,
  priceFeedAddress: ethers.constants.AddressZero,
  priceUpdateInterval: undefined,
  stabilityFee: zero,
  token: '',
  detailData: undefined,
};

export const cacheApi = process.env.REACT_APP_API_ENDPOINT;
export const POLKA_RPC = process.env.REACT_APP_POLKA_FOUNDRY_RPC;
